// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextContentEditor_wrapper__1mvQ5"};